<div class="container-fluid px-2 px-md-3 px-xl-1 py-3">
  <div class="d-flex flex-column gap-3">
    <section class="entity-config-top mb-1 rounded-4 overflow-hidden shadow-sm">
      <div class="entity-config-top-hero px-2 px-md-3 py-3">
        <div class="row g-2 align-items-start flex-nowrap">
          <div class="col">
            <h1 class="entity-page-title text-white fw-bold lh-sm mb-1">Document Management</h1>
            <p class="entity-page-subtitle text-white mb-0 subsystem-subtitle">
              Open a document form, then assign compliance and transition rules to its file questions.
            </p>
          </div>
        </div>
      </div>

      <div class="px-2 px-md-3 pb-3">
        <section class="row g-2 entity-config-top-metrics">
          <div class="col-12 col-md-6 mt-2">
            <article class="entity-metric-card h-100 rounded-4 border shadow-sm p-3">
              <div class="d-flex align-items-start justify-content-between gap-3">
                <div class="d-flex flex-column justify-content-start pt-1 ps-2">
                  <span class="entity-metric-label secondary-color text-uppercase fw-bold d-block mb-2">
                    Forms
                  </span>
                  <div class="entity-metric-value secondary-color fw-bold lh-1 mb-0 mt-1">{{ document_form_count }}</div>
                </div>

                <div class="entity-metric-icon rounded-3 d-inline-flex align-items-center justify-content-center mt-2 me-1 text-white">
                  <i class="bi bi-folder2-open"></i>
                </div>
              </div>
            </article>
          </div>

          <div class="col-12 col-md-6 mt-2">
            <article class="entity-metric-card h-100 rounded-4 border shadow-sm p-3">
              <div class="d-flex align-items-start justify-content-between gap-3">
                <div class="d-flex flex-column justify-content-start pt-1 ps-2">
                  <span class="entity-metric-label secondary-color text-uppercase fw-bold d-block mb-2">
                    Document Fields
                  </span>
                  <div class="entity-metric-value secondary-color fw-bold lh-1 mb-0 mt-1">{{ has_selected_form ? documents.length : total_document_fields }}</div>
                </div>

                <div class="entity-metric-icon rounded-3 d-inline-flex align-items-center justify-content-center mt-2 me-1 text-white">
                  <i class="bi bi-file-earmark-check"></i>
                </div>
              </div>
            </article>
          </div>
        </section>
      </div>
    </section>

      <div v-if="has_selected_form" class="d-md-none">
      <div class="input-group">
        <span class="input-group-text bg-light border-0 rounded-start-pill">
          <i class="bi bi-search text-secondary"></i>
        </span>
        <input
          v-model.trim="search_query"
          type="text"
          class="form-control form-control-sm bg-light border-0 rounded-end-pill"
          placeholder="Search documents..."
        />
      </div>
    </div>

    <section class="entity-inventory-panel rounded-4 border shadow-sm p-2">
      <div v-if="!has_selected_form" class="entity-table-head secondary-color d-none d-lg-block rounded-3 mb-2 px-3 py-2 text-uppercase tracking-wide">
        <div class="row g-2 align-items-center">
          <div class="col-lg-4">Document Form</div>
          <div class="col-lg-2">Form Type</div>
          <div class="col-lg-2">Version</div>
          <div class="col-lg-3">Coverage</div>
          <div class="col-lg-1"></div>
        </div>
      </div>

      <div v-else class="entity-table-head secondary-color d-none d-lg-block rounded-3 mb-2 px-3 py-2 text-uppercase tracking-wide">
        <div class="row g-2 align-items-center">
          <div class="col-lg-1">
            <input
              class="form-check-input"
              type="checkbox"
              :checked="all_visible_documents_selected"
              @change="toggle_select_all_documents"
            />
          </div>
          <div class="col-lg-2">Document Field</div>
          <div class="col-lg-1">Type</div>
          <div class="col-lg-4">Compliance Rule</div>
          <div class="col-lg-3">Transition Rule</div>
          <div class="col-lg-1"></div>
        </div>
      </div>

      <div v-if="loading" class="d-flex align-items-center gap-2 text-secondary text-xs py-2">
        <div class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></div>
        <span>{{ loading_forms ? 'Loading document forms...' : 'Loading document fields...' }}</span>
      </div>

      <div v-else-if="!has_selected_form && document_form_summaries.length" class="d-flex flex-column gap-2">
        <article
          v-for="form in document_form_summaries"
          :key="form.id"
          class="entity-row-card bg-white rounded-4 border shadow-sm p-3"
        >
          <div class="entity-row-layout row g-2 align-items-center">
            <div class="entity-name-block col-12 col-lg-4 d-flex align-items-start align-items-sm-center gap-3">
              <div class="entity-type-icon entity-icon-surface rounded-3 d-inline-flex align-items-center justify-content-center">
                <i class="bi bi-collection fs-5 text-primary"></i>
              </div>
              <div>
                <div class="entity-name fw-bold">{{ form.form_name }}</div>
                <div class="entity-updated text-secondary small">{{ form.form_description || 'Document form ready for field-level rule assignment.' }}</div>
              </div>
            </div>

            <div class="col-12 col-sm-4 col-lg-2">
              <span class="badge rounded-pill text-bg-light border text-secondary entity-rule-chip">
                {{ form.form_type_name || 'Document' }}
              </span>
            </div>

            <div class="col-12 col-sm-4 col-lg-2">
              <span class="text-xs fw-semibold text-secondary">v7.0.0</span>
            </div>

            <div class="col-12 col-sm-4 col-lg-3">
              <span class="text-xs fw-semibold text-secondary">
                {{ form.document_count }} document field{{ form.document_count === 1 ? '' : 's' }}, {{ form.section_count }} section{{ form.section_count === 1 ? '' : 's' }}
              </span>
            </div>

            <div class="col-12 col-lg-1 d-flex justify-content-start justify-content-lg-end align-items-center gap-2">
              <button
                type="button"
                class="btn btn-link text-decoration-none p-0 d-inline-flex align-items-center justify-content-center"
                aria-label="Open document form"
                @click="open_form_documents(form)"
              >
                <i class="bi bi-chevron-right fs-5 text-secondary"></i>
              </button>
            </div>
          </div>
        </article>
      </div>

      <div v-else-if="paginated_documents.length" class="d-flex flex-column gap-2">
        <article
          v-for="document in paginated_documents"
          :key="document.id"
          class="entity-row-card bg-white rounded-4 border shadow-sm p-3"
        >
          <div class="entity-row-layout row g-2 align-items-center">
            <div class="col-12 col-lg-1 d-flex justify-content-start justify-content-lg-center">
              <input
                class="form-check-input mt-2 mt-lg-0"
                type="checkbox"
                :checked="selected_document_ids.includes(String(document.section_question_id))"
                @change="toggle_document_selection(document)"
              />
            </div>

            <div class="entity-name-block col-12 col-lg-2 d-flex align-items-start align-items-sm-center gap-3">
              <div class="entity-type-icon entity-icon-surface rounded-3 d-inline-flex align-items-center justify-content-center">
                <i :class="[
                  'fs-5',
                  document.status === 'Required' ? 'bi bi-file-earmark-text text-primary' : 'bi bi-file-earmark-lock text-secondary'
                ]"></i>
              </div>
              <div>
                <div class="entity-name fw-bold">{{ document.name }}</div>
                <div class="entity-updated text-secondary small">{{ document.description || 'Document ready for preview and action.' }}</div>
              </div>
            </div>

            <div class="col-12 col-sm-4 col-lg-1">
              <span class="text-xs fw-semibold text-secondary">{{ document.type }}</span>
            </div>

            <div class="col-12 col-lg-4 d-flex flex-column gap-2">
              <select
                class="form-select form-select-sm rounded-3"
                :disabled="loading_rules || updating_document_rule_id === `compliance-${document.section_question_id}`"
                :value="get_document_selected_compliance_rule_id(document)"
                @change="assign_compliance_rule_to_document(document, $event.target.value)"
              >
                <option value="">No rule assigned</option>
                <option v-for="rule in rules" :key="`row-compliance-${document.section_question_id}-${rule.id}`" :value="String(rule.id)">
                  {{ rule.name }}
                </option>
              </select>

              <span
                class="badge rounded-pill border entity-rule-chip align-self-start"
                :class="is_document_compliance_configured(document) ? 'text-bg-success border-success-subtle' : 'text-bg-light text-secondary'"
              >
                {{ get_document_compliance_rule_label(document) }}
              </span>
            </div>

            <div class="col-12 col-lg-3 d-flex flex-column gap-2">
              <select
                class="form-select form-select-sm rounded-3"
                :disabled="loading_transition_rules || !transition_rules.length || updating_document_rule_id === `transition-${document.section_question_id}`"
                :value="get_document_selected_transition_rule_id(document)"
                @change="assign_transition_rule_to_document(document, $event.target.value)"
              >
                <option value="">{{ transition_rules.length ? 'No rule assigned' : 'No transition rules available' }}</option>
                <option v-for="transition_rule in transition_rules" :key="`row-transition-${document.section_question_id}-${transition_rule.id}`" :value="String(transition_rule.id)">
                  {{ transition_rule.name }}
                </option>
              </select>

              <span
                class="badge rounded-pill border entity-rule-chip align-self-start"
                :class="is_document_transition_configured(document) ? 'text-bg-success border-success-subtle' : 'text-bg-light text-secondary'"
              >
                {{ get_document_transition_rule_label(document) }}
              </span>
            </div>

            <div class="col-12 col-lg-1 d-flex justify-content-start justify-content-lg-end align-items-center gap-2">
              <button
                type="button"
               class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-2 py-1"
                @click="preview_document(document)"
                data-bs-toggle="modal"
                data-bs-target="#preview_document_modal"
              >
                View
              </button>
            </div>
          </div>
        </article>
      </div>

      <div v-else class="bg-white rounded-4 border shadow-sm p-5 text-center">
        <div class="entity-type-icon entity-icon-surface rounded-4 d-inline-flex align-items-center justify-content-center mb-3">
          <i class="bi bi-folder2-open fs-3"></i>
        </div>
        <div class="fw-bold mb-1">{{ has_selected_form ? 'No Document Fields Found' : 'No Document Forms Found' }}</div>
        <div class="text-secondary small">
          {{ has_selected_form ? 'This form has no file or document upload questions.' : 'Only forms with a document form type appear in this subsystem.' }}
        </div>
      </div>

      <div v-if="has_selected_form && !loading && paginated_documents.length" class="d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between gap-2 px-2 py-3">
        <div class="text-secondary text-xs">
          Showing {{ pagination_label }}
        </div>

        <nav aria-label="Documents pagination">
          <div class="d-inline-flex align-items-center rounded-3 border overflow-hidden bg-white">
            <button
              type="button"
              class="btn btn-sm btn-light border-0 rounded-0 px-2"
              @click="set_page(current_page - 1)"
              :disabled="current_page === 1"
              aria-label="Previous page"
            >
              <i class="bi bi-chevron-left"></i>
            </button>

            <button
              v-for="page in total_pages"
              :key="page"
              type="button"
              class="btn btn-sm rounded-0 border-0 border-start px-3 pagination-seg-btn"
              :class="page === current_page ? 'btn-primary-dark text-white' : 'btn-light'"
              @click="set_page(page)"
            >
              {{ page }}
            </button>

            <button
              type="button"
              class="btn btn-sm btn-light border-0 border-start rounded-0 px-2"
              @click="set_page(current_page + 1)"
              :disabled="current_page === total_pages"
              aria-label="Next page"
            >
              <i class="bi bi-chevron-right"></i>
            </button>
          </div>
        </nav>
      </div>
    </section>
  </div>
</div>

<teleport to="body">
  <div
    class="modal fade"
    id="preview_document_modal"
    tabindex="-1"
    aria-labelledby="preview_document_modal_label"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content bg-white rounded-4 p-0 shadow-lg">
        <div class="modal-header border-bottom-0 cute-header shadow-lg">
          <p class="modal-title text-white text-xs mb-0" id="preview_document_modal_label">
            Document Preview
          </p>
          <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <div class="modal-body p-0">
          <div v-if="selected_document" class="d-flex flex-column">
            <div class="p-4 border-bottom">
              <div class="fw-bold">{{ selected_document.name }}</div>
              <div class="text-secondary small mt-1">
                {{ selected_document.description || 'No document description available.' }}
              </div>
            </div>

            <div class="p-4">
              <div class="bg-light rounded-4 border p-3 mb-3 shadow-sm">
                <div class="d-flex align-items-start justify-content-between gap-2 mb-3">
                  <div>
                    <div class="fw-bold secondary-color">Compliance Rule</div>
                    <div class="small text-secondary">Selected compliance rule values for this document field.</div>
                  </div>
                  <span
                    class="badge rounded-pill"
                    :class="is_document_compliance_configured(selected_document) ? 'text-bg-success' : 'text-bg-secondary'"
                  >
                    {{ get_document_compliance_rule_label(selected_document) }}
                  </span>
                </div>

                <div v-if="get_document_assigned_compliance_rules(selected_document).length" class="row g-3">
                  <div class="col-12">
                    <label class="modal-form-label form-label text-xxs">Rule Name</label>
                    <input
                      type="text"
                      class="form-control rounded-3 bg-white"
                      :value="get_document_assigned_compliance_rules(selected_document)[0]?.rule_name || 'No rule assigned'"
                      readonly
                    />
                  </div>
                  <div class="col-12">
                    <div class="d-flex flex-wrap gap-2">
                      <span class="badge rounded-pill text-bg-light border text-secondary">
                        {{ selected_document.status }}
                      </span>
                      <span
                        v-for="assignment in get_document_assigned_compliance_rules(selected_document)"
                        :key="`preview-${selected_document.section_question_id}-${assignment.rule_id}`"
                        class="badge rounded-pill text-bg-light border text-secondary"
                      >
                        {{ assignment.rule_name }}
                      </span>
                      <span
                        v-if="get_document_assigned_compliance_rules(selected_document)[0]?.compliance_field_id"
                        class="badge rounded-pill text-bg-light border text-secondary"
                      >
                        Field #{{ get_document_assigned_compliance_rules(selected_document)[0].compliance_field_id }}
                      </span>
                    </div>
                  </div>
                </div>
                <div v-else class="small text-secondary">
                  No compliance rule assigned to this document field.
                </div>
              </div>

              <div class="bg-light rounded-4 border p-3 mb-3 shadow-sm">
                <div class="d-flex align-items-start justify-content-between gap-2 mb-3">
                  <div>
                    <div class="fw-bold secondary-color">Transition Rule</div>
                    <div class="small text-secondary">Selected workflow transition rule for this document field.</div>
                  </div>
                  <span
                    class="badge rounded-pill"
                    :class="is_document_transition_configured(selected_document) ? 'text-bg-success' : 'text-bg-secondary'"
                  >
                    {{ get_document_transition_rule_label(selected_document) }}
                  </span>
                </div>

                <div v-if="get_document_assigned_transition_rules(selected_document).length" class="row g-3">
                  <div class="col-12">
                    <label class="modal-form-label form-label text-xxs">Transition</label>
                    <input
                      type="text"
                      class="form-control rounded-3 bg-white"
                      :value="get_document_assigned_transition_rules(selected_document)[0]?.name || 'No rule assigned'"
                      readonly
                    />
                  </div>
                  <div class="col-12">
                    <div class="d-flex flex-wrap gap-2">
                      <span class="badge rounded-pill text-bg-light border text-secondary">
                        {{ selected_document.status }}
                      </span>
                      <span class="badge rounded-pill text-bg-light border text-secondary">
                        Document #{{ selected_document.section_question_id }}
                      </span>
                    </div>
                  </div>
                </div>
                <div v-else class="small text-secondary">
                  No transition rule assigned to this document field.
                </div>
              </div>
            </div>
          </div>
          <div v-else class="p-4 text-center text-secondary text-xs">No document selected.</div>
        </div>
      </div>
    </div>
  </div>
</teleport>
